import { BasePool } from "../pool";
import type { ServiceContainer, ServiceProvider } from "../service-container";
import type { ColorStringParsersPool } from "./ColorStringParsersPool";
import { CompositeColorStringParser } from "./CompositeColorStringParser";
import { HexColorStringParser } from "./HexColorStringParser";
import { RgbaColorStringParser } from "./RgbaColorStringParser";
import { TransparentStringParser } from "./TransparentStringParser";

/**
 * Color string parsing service provider.
 * @internal
 */
export const colorStringParserProvider: ServiceProvider = {
  /**
   * Registers entities, related to color string parsing, in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: ColorStringParsersPool = new BasePool();
    pool.add("transparent", new TransparentStringParser());
    pool.add("hex", new HexColorStringParser());
    pool.add("rgba", new RgbaColorStringParser());

    container.register("ColorStringParsersPool", pool);

    container.register(
      "ColorStringParser",
      (c) => new CompositeColorStringParser(c.resolve("ColorStringParsersPool"))
    );
  },
};
